import { render } from "./LanguageSelector.vue?vue&type=template&id=98a65492"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"

import "./LanguageSelector.vue?vue&type=style&index=0&id=98a65492&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__